$_buttonWidth: 4em;
$searchInputHeightDark: rem(2.25); //36px
$searchInputHeightLight: rem(2.625); //42px

:host {
  --ds-search-input-height: #{$searchInputHeightDark};
  display: block;
  position: relative;
  inline-size: 100%;
}

:host(.search--masthead) {
  --ds-search-input-background-color: var(--cxsShell_SearchBackground);
  --ds-search-input-color: var(--cxsShell_SearchTextColor);
  --ds-search-input-icon-search-color: var(--cxsShell_SearchIconColor);
  --ds-search-input-border: var(--cxsShell_SearchBorder);
  --ds-search-placeholder-color: var(--cxsShell_SearchPlaceholderColor);
  //hover
  --ds-search-input-hover-color: var(--ds-search-input-color);
  --ds-search-input-hover-backgroud: var(--cxsShell_Hover_SearchBackground);
  --ds-search-input-hover-borderColor: var(--cxsShell_Hover_SearchBorder);
}

:host(.search--menu) {
  --ds-search-input-background-color: var(--cxsShell_MenuSearchBackground);
  --ds-search-input-color: var(--cxsShell_MenuSearchTextColor);
  --ds-search-input-icon-search-color: var(--cxsShell_MenuSearchIconColor);
  --ds-search-input-border: var(--cxsShell_MenuSearchBorder);
  --ds-search-placeholder-color: var(--cxsShell_MenuSearchPlaceholderColor);
  //hover
  --ds-search-input-hover-color: var(--cxsShell_MenuSearchBackground);
  --ds-search-input-hover-backgroud: var(--cxsShell_MenuSearchBackground);
  --ds-search-input-hover-borderColor: var(--cxsShell_MenuSearchBorder);
}

.search-input-wrapper {
  display: flex;
  position: relative;
  align-items: center;
  box-sizing: border-box;
  inline-size: 100%;
  block-size: var(--ds-search-input-height);
  border: var(--ds-search-input-border);
  border-radius: calc(var(--ds-search-input-height) / 2);
  background-color: var(--ds-search-input-background-color);
  z-index: 1000;

  &:focus-within {
    border:  var(--cxsShell_Active_SearchBorder);
    background-color: var(--cxsShell_Active_SearchBackground);
    font-style: normal;

    .search-input {
      font-style: normal;
    }

    .search-button {
      ds-icon {
        --ds-icon-color: var(--cxsShell_Active_SearchIconColor);
      }
    }
  }

  &:hover:not(:focus-within) {
    border:  var(--ds-search-input-hover-borderColor);
    background-color: var(--ds-search-input-hover-backgroud);

    &::placeholder {
      opacity: 1;
      color: var(--ds-search-input-hover-color);
    }

    ~ .search-button {
      ds-icon {
        --ds-icon-color: var(--ds-search-input-hover-color);
      }
    }
  }

  .search-input {
    position: absolute;
    inset-inline-start: 0;
    inline-size: 114%;
    padding-inline: var(--cxs-spacer-xm) var(--cxs-spacer-xm);
    padding-block: var(--cxs-spacer-s);
    transform: scale(.875);
    transform-origin: left center;
    border: none;
    outline: 0;
    background-color: transparent;
    color: var(--ds-search-input-color);
    font: var(--cxsShell_SearchFont);
    font-style: italic;

    &.rtl {
      transform-origin: right center;
    }

    &:focus {
      color: var(--cxsShell_Active_SearchTextColor);

      &::placeholder {
        color: var(--cxsShell_Active_SearchTextColor);
      }
    }

    &::-webkit-search-cancel-button {
      display: none;
    }

    &::placeholder {
      opacity: 1;
      color: var(--ds-search-placeholder-color);
    }
  }

  .search-button {
    --button-padding: 0;
    display: flex;
    justify-content: center;
    inline-size: $_buttonWidth;

    &--submit,
    &--clean {
      --button-padding: 0;
      position: absolute;
      inset-inline-end: var(--cxs-spacer-s);
      inline-size: rem(2);

      ds-icon {
        --ds-icon-color: var(--ds-search-input-icon-search-color);
      }
    }
  }

  &--with-submit {
    .search-input {
      padding-inline-end: rem(5);
    }

    .search-button {
      &--clean {
        inset-inline-end: rem(2.55);
      }
    }

    &.search-input-wrapper--with-text {
      &:focus-within {
        .search-button--submit {
          inline-size: rem(1.75);
          block-size: rem(1.75);
          border-radius: 50%;
          background-color: var(--cxsShell_Active_SearchHighlightIconBackground);

          ds-icon {
            --ds-icon-color: var(--cxsShell_Active_SearchHighlightIconColor);
          }
        }
      }
    }
  }

}

[data-mode='light'] {
  $iconSize: 1.125; //18px
  $iconActiveSize: 1.75; //28px
  $inputSpacers: .75; //12px
  $activeIconSpacers: .4375; //7px

  --ds-search-input-height: #{$searchInputHeightLight};

  .search-input-wrapper {
    .search-button--submit,
    .search-button--clean {
      ds-icon {
        --ds-icon-width: #{rem($iconSize)};
        --ds-icon-height: #{rem($iconSize)};
      }
    }

    .search-button {
      inline-size: rem($iconActiveSize);
    }

    .search-button--submit {
      inset-inline-end: rem($activeIconSpacers);
    }

    .search-button--clean {
      inset-inline-end: rem($inputSpacers);
    }

    &--with-submit {
      .search-input {
        padding-inline-end: rem($inputSpacers * 2 + 3 * $iconSize);
      }

      .search-button--clean {
        inset-inline-end: rem($iconSize + 2 * $inputSpacers);
      }
    }
  }

  .search-input {
    padding-inline: rem($inputSpacers) rem($inputSpacers * 2 + $iconSize);
    font-style: normal;
  }
}
